var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H10.6666V11.3333H12M12 7.33333H10.6666V8.66667H12M13.3333 12.6667H7.99998V11.3333H9.33331V10H7.99998V8.66667H9.33331V7.33333H7.99998V6H13.3333M6.66665 4.66667H5.33331V3.33333H6.66665M6.66665 7.33333H5.33331V6H6.66665M6.66665 10H5.33331V8.66667H6.66665M6.66665 12.6667H5.33331V11.3333H6.66665M3.99998 4.66667H2.66665V3.33333H3.99998M3.99998 7.33333H2.66665V6H3.99998M3.99998 10H2.66665V8.66667H3.99998M3.99998 12.6667H2.66665V11.3333H3.99998M7.99998 4.66667V2H1.33331V14H14.6666V4.66667H7.99998Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.7fd660b6fa85402155cbac905c552675.svg";
export { ForwardRef as ReactComponent };